import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const createLead = async ({ name, whatsapp, source }) => {
    const { data } = await api.post("/leads", { name, whatsapp, source });
    return data;
};

export const adminLogin = async (password) => {
    const { data } = await api.post("/admin/login", { password });
    return data.token;
};

export const fetchLeads = async (token) => {
    const { data } = await api.get("/admin/leads", {
        headers: { "X-Admin-Password": token },
    });
    return data;
};

export const fetchStats = async (token) => {
    const { data } = await api.get("/admin/stats", {
        headers: { "X-Admin-Password": token },
    });
    return data;
};

export const deleteLead = async (token, id) => {
    const { data } = await api.delete(`/admin/leads/${id}`, {
        headers: { "X-Admin-Password": token },
    });
    return data;
};
